import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ShowVisibleNextAtd,
  ShowInfoDisplay,
  addMessage,
  CloseChat,
  SendNextAtd,
  CloseAttendant,
  InterationNotifier,
  RemoveRemoteNotifier,
  addChat,
  SendNextChat,
  CallConsultaInterna,
  EndcallConsultIndex,
  TransferCall,
  ConferenceCall,
  CallConferenciaInterna,
  clearConferenceExt,
} from "../actions";
import MicroModal from "micromodal";
import TimeCounter from "../containers/TimeCounter";
import {
  InviteChats,
  sendtypinwebsocket,
  SendSocketTransferCallIn,
  sendtypinwebsocketchat,
} from "../actions/websocket";
import Moment from "moment";
import LOADING from "../build/images/typing.gif";
import Highlighter from "react-highlight-words";
import ModalImage from "react-modal-image";
import AVI from "../build/images/avi-file.png";
import JPG from "../build/images/jpg-file.png";
import PNG from "../build/images/png-file.png";
import MP4 from "../build/images/mp4-file.png";
import SVG from "../build/images/svg-file.png";
import PDF from "../build/images/pdf-file.png";
import MP3 from "../build/images/mp3-file.png";
import latinize from "latinize";
import { stat } from "fs";
import { TippyPopper } from "../actions/Tippy";

const { connection_platform } = require("../services/api");

var refs = [];
var contmsg = 0;
var scroller = false;

var typingTimer;
var doneTypingInterval = 5000;
var digitando = 0;
var mensagensnaolidas = [];
var outroatendimento = [];
var valuescroll = 0;
var contConsulta = 0;

const { meses } = require("../services/data");

var ipcurrent = "";
var gethostname = window.location.hostname;
var pathname = "";
var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  //if(parseInt(connection_platform.port_apache_view_extern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

function makeid(length) {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

const mapStateToProps = (state) => {
  return {
    Messages: state.messages,
    Typing: state.typing,
    InfoUsers: state.informationusers,
    AtdSimult: state.atdsimult,
    ChatSimult: state.chatsimult,
    IPCurrent: state.ipcurrent,
    Chat: state.chatinternal,
    ContactId: state.atendimento,
    CurrentScreen: state.currentscreen,
    Agents: state.agents,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ShowVisibleNextAtdIn: (post, temp) => {
    dispatch(ShowVisibleNextAtd(post, temp));
  },
  clearConference: (atendimento) => {
    dispatch(clearConferenceExt());
  },
  ShowInfoDisplay: (post) => {
    dispatch(ShowInfoDisplay(post));
  },
  ByeChat: (chat) => {
    dispatch(CloseChat(chat));
  },
  sendtyping: (typing, InfoUsers, Chat) => {
    if (digitando === 0) {
      sendtypinwebsocketchat(1, InfoUsers, Chat);
      digitando = 1;
      clearTimeout(typingTimer);
      typingTimer = setTimeout(doneTyping, doneTypingInterval);
    } else {
      doneTypingInterval = 5000;
    }

    function doneTyping() {
      digitando = 0;
      sendtypinwebsocketchat(0, InfoUsers, Chat);
    }
  },
  ProximoChat: (proximoatd) => {
    SendNextChat(proximoatd)(dispatch);
  },
  EndcallConsult: (event, agent) => {
    dispatch(EndcallConsultIndex(event, agent));
  },
  ByeAttendant: (contactid, infousers, reason) => {
    dispatch(CloseAttendant(contactid, infousers, reason));
  },
  TransferCall: (user) => {
    dispatch(TransferCall(user));
  },
  ConferenceCall: (user) => {
    dispatch(ConferenceCall(user));
  },
  InterationNotifierIn: (texto, status) => {
    dispatch(InterationNotifier(texto, status));
  },
  ConsultaInternaCall: (number, iduser, agent) => {
    dispatch(CallConsultaInterna(number, iduser, agent));
  },
  ConferenciaInternaCall: (contactId, chat) => {
    dispatch(CallConferenciaInterna(contactId, chat));
  },
  InviteChat: (
    makeid,
    message,
    author,
    infousers,
    chat,
    typemsg,
    msgsocket
  ) => {
    let time = Moment().format("HH:mm");
    let dia = Moment().format("DD");
    let mes = Moment().format("MM");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];
    if (message != "") {
      dispatch(
        addMessage(
          makeid,
          message,
          author,
          time,
          chat.iduserout,
          typemsg,
          "enviado",
          false,
          dia
        ),
        InviteChats(infousers, chat.iduserout, msgsocket, author, makeid)
      );
    }
  },
  ProximoAtendimento: (proximoatd, novamensagem, contactid, infousers) => {
    SendNextAtd(proximoatd, novamensagem, contactid, infousers)(dispatch);
  },
  RemoveRemoteNotifier: (post) => {
    dispatch(RemoveRemoteNotifier(post));
  },
  ChangeChatSimult: (infouser, chat, active) => {
    let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
    dispatch(
      addChat(chat.iduserout, chat.agent, active, chat.voz, 0, datatime)
    );
    dispatch(RemoveRemoteNotifier(chat.iduserout));
  },
  sendSocketActionTransferCall: (
    infousers,
    ContactId,
    agent,
    atdsimult,
    outservices,
    servicegroup,
    ipcurrent,
    module
  ) => {
    const socket = SendSocketTransferCallIn(
      infousers,
      ContactId,
      agent,
      atdsimult,
      outservices,
      servicegroup,
      dispatch,
      ipcurrent,
      module
    );

    if (atdsimult.length === 1) dispatch(ShowVisibleNextAtd(true, true));
  },
});

class ChatSimult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileasw: [],
      visible: "",
      searchText: "",
      typing: [],
      expand_less_count: 0,
      expandAgent: [],
      expand_more_count: 0,
      chatsimult: [],
      atdsimult: [],
      remotescreen: props.remotescreen,
      chatemcurso: props.chatemcurso,
      consultacall: false,
      isTransfering: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    let chatsimult = prevState.chatsimult;
    chatsimult.map((simult) => {
      if (document.getElementById("containerminichat" + simult.iduserout)) {
        let result = prevState.messages[simult.iduserout];
        if (result != undefined) {
          // if(valuescroll != result.length && scroller === true){
          //   document.getElementById('containerminichat'+simult.iduserout).scrollTop = document.getElementById('containerminichat'+simult.iduserout).scrollHeight
          //   scroller = false
          // // }
          if (contmsg != result.length) {
            document.getElementById(
              "containerminichat" + simult.iduserout
            ).scrollTop = document.getElementById(
              "containerminichat" + simult.iduserout
            ).scrollHeight;
            scroller = false;
          }
          valuescroll = result.length;
          contmsg = result.length;
        }
      }
    });
  }

  componentWillUnmount() {
    if (this.throttleTimeout) {
      clearTimeout(this.throttleTimeout); // cancela caso o componente seja desmontado
    }
  }

  ShowInfoDisplay(e, display) {
    if (display === "mensagemchat") {
      this.props.ShowInfoDisplay("Arquivos");
      MicroModal.close("modal__notificacoes");
    } else if (display === "mensagemgrupo") {
      MicroModal.show("modal__mensagem-equipe");
      MicroModal.close("modal__notificacoes");
    }
    document.getElementById("simulation_click").click();
    this.setState({ newnotifier: false });
  }

  MoreChats(e) {
    e.preventDefault();
    this.setState({ buttonMore: !this.state.buttonMore });
  }

  handleKeyPressChat = (event, id) => {
    var el = document.getElementById("chat-message-mini-chat" + id);
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };

  scrollDownChat(id) {
    let referencia = this.refs;
    // referencia.containerchat.scrollTop = referencia.containerchat.scrollHeight
    document.getElementById("containerminichat" + id).scrollTop =
      document.getElementById("containerminichat" + id).scrollHeight;
    scroller = true;
  }

  handleKeyDownChat = (event, id) => {
    var el = document.getElementById("chat-message-mini-chat" + id);
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };

  checkExpandAgent(e, idchatsimult, infouser, simult, chat) {
    if (chat.active === false && chat.iduserout === idchatsimult) {
      if (this.state.remotescreen != "chatinternal") {
        this.setState({
          expandAgent: [idchatsimult],
        });
      }
      this.setState({ chatatual: idchatsimult });
      mensagensnaolidas[idchatsimult] = 0;
      this.props.ChangeChatSimult(infouser, simult, true);
    } else if (chat.active === true && chat.iduserout === idchatsimult) {
      this.setState({
        expandAgent: this.state.expandAgent.filter(function (val) {
          return val != idchatsimult;
        }),
      });
      this.setState({ chatatual: 0 });
      this.props.ChangeChatSimult(infouser, simult, false);
      mensagensnaolidas[idchatsimult] = 0;
    } else {
      mensagensnaolidas[idchatsimult] = 0;
      this.setState({
        expandAgent: this.state.expandAgent.filter(function (val) {
          return val != idchatsimult;
        }),
      });
      this.setState({ chatatual: 0 });
      this.props.ChangeChatSimult(infouser, simult, true);
    }
  }

  CallChamada(event, simult, InfoUsers, Chat, agents) {
    this.setState({ consultacall: true });

    let element = document.getElementById("active-chats__extra");
    element.classList.add("active-chats__extra--in-call");

    let useragent = agents.filter(function (val) {
      if (val.iduser == simult.iduser) return val.iduser;
    });

    this.props.ConsultaInternaCall(
      useragent[0].ramal,
      useragent[0].value,
      useragent[0]
    );
    //this.props.clearConference(simult)
  }

  ConferenceAgent(contactId, chat) {
    this.props.ConferenciaInternaCall(contactId, chat);
  }

  handleOnChangeChat(event, InfoUsers, Chat, id) {
    if (event.key === "Enter" && event.shiftKey === false) {
      //let teste = document.getElementsByClassName('chat-message-mini-chat'+id);
      let msgweb = document.getElementById(
        "chat-message-mini-chat" + id
      ).innerText;
      let msgsocket = document.getElementById(
        "chat-message-mini-chat" + id
      ).innerText;
      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        this.props.InviteChat(
          makeid(32),
          msgweb,
          InfoUsers.id,
          InfoUsers,
          Chat,
          "0",
          msgsocket
        );
        document.getElementById("chat-message-mini-chat" + id).innerHTML = "";
        this.scrollDownChat(id);
        this.props.sendtyping(0, InfoUsers, Chat);
      }
    } else {
      this.props.sendtyping(1, InfoUsers, Chat);
    }
    this.textInputChat.focus();
  }

  ByeChat(event, simult, chat, chatsimult) {
    event.preventDefault();

    delete mensagensnaolidas[simult.iduserout];
    delete outroatendimento[simult.iduserout];

    if (chatsimult.length > 1) {
      let i = 0;
      // if(chat.iduserout == simult.iduserout)
      //   i = 1;
      this.props.ProximoChat(chatsimult[i]);
    }
    this.props.ByeChat(simult);

    if (simult.voz === true && simult.line > 0) {
      this.props.EndcallConsult(event, simult);
    }
  }

  ButtonSendMessageChat(event, author, InfoUsers, Chat, typemsg, id) {
    event.preventDefault();
    // document.getElementById('chat-message-mini-chat'+id).disabled = false;
    let msgweb = document.getElementById(
      "chat-message-mini-chat" + id
    ).innerText;
    let msgsocket = document.getElementById(
      "chat-message-mini-chat" + id
    ).innerText;

    let infosendfile = this.state.fileasw;

    if (
      this.state.fileasw != null &&
      infosendfile[2] != 1 &&
      infosendfile.length > 0
    ) {
      msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
      msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        this.props.sendFileAswSocket(
          InfoUsers,
          Chat,
          infosendfile[0],
          msgweb,
          makeid(32)
        );
        this.props.sendImageAsw(
          makeid(32),
          " ~¿" + msgweb + "~¿" + infosendfile[0],
          InfoUsers.id,
          InfoUsers,
          Chat,
          1
        );
      }
    } else {
      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        this.props.InviteChat(
          makeid(32),
          msgweb,
          InfoUsers.id,
          InfoUsers,
          Chat,
          "0",
          msgsocket
        );
        document.getElementById("chat-message-mini-chat" + id).innerHTML = "";
        this.scrollDownChat(id);
        this.props.sendtyping(0, InfoUsers, Chat);
      }
    }
    this.scrollDownChat(Chat.iduserout);
    document.getElementById("chat-message-mini-chat" + id).innerHTML = "";
    this.textInputChat.focus();
  }

  CallConsultDisconnect(event, simult) {
    this.setState({ consultacall: false });
    let element = document.getElementById("active-chats__extra");
    element.classList.remove("active-chats__extra--in-call");
    this.props.EndcallConsult(event, simult);
  }

  TransferAgent(
    event,
    infousers,
    ContactId,
    agent,
    atdsimult,
    Messages,
    outservices,
    servicegroup,
    agents,
    ipcurrent
  ) {
    let erro = true;
    let moduloUser = 0;

    agents.map((user) => {
      if (agent.iduser === user.iduser) {
        if (user.status === null && user.status_sip === null) {
          erro = false;
        }
        moduloUser = user.usedmodule;
      }
    });

    if (ContactId.length !== 0) {
      if (erro) {
        if (infousers.id) {
          delete mensagensnaolidas[ContactId.idatendimento];
          delete outroatendimento[ContactId.idatendimento];
          if (ContactId.length != 0) {
            this.props.sendSocketActionTransferCall(
              infousers,
              ContactId,
              agent,
              atdsimult,
              outservices,
              servicegroup,
              ipcurrent,
              moduloUser
            );
            // const socket = SendSocketTransferCallIn(infousers, ContactId, agent, atdsimult, outservices, servicegroup)
            this.props.TransferCall(infousers);
          } else {
            this.props.ByeAttendant(ContactId, infousers, "transferencia");
          }
        }
        document.getElementById("simulation_click").click();
      } else {
        this.props.InterationNotifierIn(
          "Este usuário encontra-se deslogado",
          "toastgrupo"
        );
      }
    } else {
      this.props.InterationNotifierIn(
        "Não existe chamada para transferir",
        "toastgrupo"
      );
    }
  }

  renderPopover = (e, name) => <span className="action-label">{name}</span>;

  render() {
    const {
      ChatSimult,
      Messages,
      InfoUsers,
      Chat,
      Typing,
      IPCurrent,
      ContactId,
      AtdSimult,
      CurrentScreen,
      Agents,
    } = this.props;
    const { searchText } = this.state;
    const searchWords = searchText.split(/\s/).filter((word) => word);
    let input;
    var typing_w = "";
    var dia = "";
    var auxdia = "";

    if (Typing.length != 0) {
      this.state.typing = Typing;
    }

    this.state.typing.map((typingtodo) => {
      if (
        typingtodo.typing == "1" &&
        typingtodo.idatendimento == Chat.iduserout
      ) {
        typing_w = (
          <div className="message left" style={{ marginTop: "20px" }}>
            <div className="bubble">
              <img src={LOADING} alt="" className="bubble__typing" width="48" />
            </div>
          </div>
        );
      }
    });

    if (Chat.length != 0) {
      this.state.chatsimult = ChatSimult;
    } else {
      this.state.chatsimult = [];
    }

    if (AtdSimult.length != 0) {
      this.state.atdsimult = AtdSimult;
    } else {
      this.state.atdsimult = [];
    }

    if (Agents.length != 0) {
      this.state.lsusersatd = Agents;
    } else {
      this.state.lsusersatd = [];
    }

    if (Messages.length != 0) {
      var NovaMensagemC = Messages;
      this.state.messages = Messages;
      var Contador = [];

      if (NovaMensagemC === undefined) {
        var NovaMensagemC = [];
      }
    } else {
      var NovaMensagemC = [];
      this.state.messages = [];
    }

    if (this.state.remotescreen === "chatinternal") {
      mensagensnaolidas[Chat.iduserout] = 0;
    }

    return (
      <>
        {this.state.chatsimult.map((simult, index) => (
          <li
            className="active-chats__tab gestor"
            style={{
              display:
                parseInt(simult.iduserout) === parseInt(Chat.iduserout) &&
                this.state.remotescreen === "chatinternal"
                  ? "none"
                  : "block",
            }}
            id="chat-active-caixa"
            key={index + simult.iduserout}
          >
            <i
              onClick={(event) => this.ByeChat(event, simult, Chat, ChatSimult)}
              style={{
                display:
                  this.state.remotescreen === "chatinternal" ? "none" : "block",
              }}
              className="active-chats__close-btn material-icons"
            >
              close
            </i>
            {(() => {
              if (
                parseInt(simult.iduserout) != parseInt(Chat.iduserout) &&
                Messages[simult.iduserout] != undefined
              ) {
                if (
                  Messages[simult.iduserout].length !=
                    outroatendimento[simult.iduserout] &&
                  outroatendimento[simult.iduserout] != undefined
                ) {
                  outroatendimento[simult.iduserout] =
                    Messages[simult.iduserout].length;
                  mensagensnaolidas[simult.iduserout] =
                    isNaN(parseInt(mensagensnaolidas[simult.iduserout])) == true
                      ? 1
                      : parseInt(mensagensnaolidas[simult.iduserout]) + 1;
                }
              } else if (Messages[simult.iduserout] != undefined) {
                if (
                  parseInt(simult.iduserout) === parseInt(Chat.iduserout) &&
                  Chat.active === false &&
                  CurrentScreen.screen != "Atendentes"
                ) {
                  if (
                    Messages[simult.iduserout].length !=
                    outroatendimento[simult.iduserout]
                  ) {
                    outroatendimento[simult.iduserout] =
                      Messages[simult.iduserout].length;
                    mensagensnaolidas[simult.iduserout] =
                      isNaN(parseInt(mensagensnaolidas[simult.iduserout])) ==
                      true
                        ? 1
                        : parseInt(mensagensnaolidas[simult.iduserout]) + 1;
                  }
                } else {
                  outroatendimento[simult.iduserout] =
                    Messages[simult.iduserout].length;
                  mensagensnaolidas[simult.iduserout] = 0;
                }
              } else if (this.state.remotescreen === "chatinternal") {
                mensagensnaolidas[Chat.iduserout] = 0;
              }
              if (
                simult.active === "computer" &&
                mensagensnaolidas[simult.iduserout] === undefined
              ) {
                mensagensnaolidas[simult.iduserout] = 1;
              }
              if (
                mensagensnaolidas[simult.iduserout] === undefined ||
                mensagensnaolidas[simult.iduserout] === "0" ||
                mensagensnaolidas[simult.iduserout] === 0
              ) {
                return "";
              } else {
                return (
                  <span className="active-chats__counter">
                    {mensagensnaolidas[simult.iduserout]}
                  </span>
                );
              }
            })()}
            {(() => {
              let className = "active-chats__extra";

              if (Chat.iduserout === simult.iduserout && Chat.active === true) {
                this.state.consultacall = false;
                className = className + " active";
              }

              if (
                Chat.voz === true &&
                Chat.active === true &&
                Chat.iduserout === simult.iduserout
              ) {
                this.state.consultacall = true;
                className = className + " active-chats__extra--in-call";
              }

              let timeatual = Moment().format("YYYY/MM/DD HH:mm:ss");
              let duracao = Moment(timeatual).diff(simult.dateinit, "seconds");

              let checkstatus = true;
              let callconsult = false;
              let transfcega = false;
              let transferPause = true;

              console.log("INGENIUM_STATUS_AGT_0 : ", this.state.lsusersatd);

              this.state.lsusersatd.map((user) => {
                if (parseInt(Chat.iduserout) === parseInt(user.iduser)) {
                  //if(((user.status==="AT" && parseInt(user.mediaid)===1)||(user.status==="RV")||(user.status === null)||(user.status_sip === null))&&(Chat.voz===false)){

                  if (
                    ((user.status === "AT" && parseInt(user.mediaid) === 1) ||
                      // ||(user.status==="BQ")
                      user.status === "RV" ||
                      // ||(parseInt(user.futurepause)===1)
                      user.status === null ||
                      user.status === "null" ||
                      user.status_sip === null ||
                      user.status_sip === "null") &&
                    !Chat.voz
                  ) {
                    console.log("INGENIUM_STATUS_AGT_1_5 : PASSOU");
                    checkstatus = false;
                  }

                  if (
                    user.status === "BQ" ||
                    parseInt(user.futurepause) === 1
                  ) {
                    console.log("INGENIUM_STATUS_AGT_1_5 : PASSOU");
                    transferPause = false;
                  }

                  if (parseInt(simult.line) > 0 && simult.atendimento == true) {
                    //setTimeout(() => {
                    callconsult = true;
                    transfcega = false;
                    //}, 1500);
                  } else if (
                    parseInt(simult.line) <= 0 ||
                    simult.line === undefined
                  ) {
                    transfcega = true;
                  }
                }
              });

              let agentConsult = Agents.filter(
                (opr) => parseInt(opr.iduser) === parseInt(simult.iduserout)
              );
              let containsOne = false;

              if (
                agentConsult &&
                agentConsult != "" &&
                agentConsult[0].jsoncall
              ) {
                containsOne = agentConsult[0].jsoncall
                  .split("¿")
                  .some((part) => part.split("§").includes("1"));
              }

              return (
                <div id="active-chats__extra" className={className}>
                  <div className="top">
                    <p
                      className="top__label"
                      onClick={(event) =>
                        this.checkExpandAgent(
                          event,
                          simult.iduserout,
                          InfoUsers,
                          simult,
                          Chat
                        )
                      }
                    >
                      {simult.agent}
                    </p>
                    <div className="top-options">
                      {(() => {
                        console.log(
                          "INGENIUM_STATUS_AGT : ",
                          checkstatus,
                          callconsult,
                          this.state.consultacall,
                          containsOne,
                          transferPause
                        );

                        if (
                          checkstatus === true &&
                          callconsult === false &&
                          this.state.consultacall === false &&
                          !containsOne
                        ) {
                          return (
                            <TippyPopper
                              content={this.renderPopover(
                                this,
                                "Consultar agente"
                              )}
                            >
                              <a
                                href="#"
                                className="top-options__icon tippy-default"
                                data-tippy-content="Consultar por voz"
                                onClick={(event) =>
                                  this.CallChamada(
                                    event,
                                    simult,
                                    InfoUsers,
                                    Chat,
                                    Agents
                                  )
                                }
                              >
                                <i className="material-icons">phone</i>
                              </a>
                            </TippyPopper>
                          );
                        } else {
                          return (
                            <TippyPopper
                              content={this.renderPopover(
                                this,
                                "Só é permitido consultar o agente caso esteja livre"
                              )}
                            >
                              <a
                                href="#"
                                className="top-options__icon tippy-default disable"
                                data-tippy-content="Consultar por voz"
                              >
                                <i className="material-icons">phone</i>
                              </a>
                            </TippyPopper>
                          );
                        }
                      })()}
                      {(() => {
                        if (
                          checkstatus === true &&
                          (callconsult === true ||
                            (transfcega == true && !containsOne)) &&
                          transferPause === true
                        ) {
                          return (
                            <TippyPopper
                              content={this.renderPopover(
                                this,
                                "Transferir chamada"
                              )}
                            >
                              <a
                                href="#"
                                className="top-options__icon"
                                onClick={(event) => {
                                  if (this.state.isTransfering) return;
                                  this.setState({ isTransfering: true });

                                  this.TransferAgent(
                                    event,
                                    InfoUsers,
                                    ContactId,
                                    simult,
                                    this.state.atdsimult,
                                    this.state.messages,
                                    this.state.outservices,
                                    this.state.servicegroup,
                                    Agents,
                                    IPCurrent
                                  );

                                  this.throttleTimeout = setTimeout(() => {
                                    this.setState({ isTransfering: false });
                                  }, 3000);
                                }}
                              >
                                <i className="material-icons">
                                  phone_forwarded
                                </i>
                              </a>
                            </TippyPopper>
                          );
                        } else {
                          return (
                            <TippyPopper
                              content={this.renderPopover(
                                this,
                                "Só é permitido transferir chamada com o agente livre ou realizando uma consulta antes"
                              )}
                            >
                              <a href="#" className="top-options__icon disable">
                                <i className="material-icons">
                                  phone_forwarded
                                </i>
                              </a>
                            </TippyPopper>
                          );
                        }
                      })()}
                      {(() => {
                        if (checkstatus === true) {
                          return (
                            <TippyPopper
                              content={this.renderPopover(
                                this,
                                "Criar conferência"
                              )}
                            >
                              <a
                                href="#"
                                className="top-options__icon"
                                onClick={(event) =>
                                  this.ConferenceAgent(ContactId, Chat)
                                }
                              >
                                <i className="material-icons">group_add</i>
                              </a>
                            </TippyPopper>
                          );
                        } else {
                          return (
                            <TippyPopper
                              content={this.renderPopover(
                                this,
                                "Criar conferência"
                              )}
                            >
                              <a href="#" className="top-options__icon disable">
                                <i className="material-icons">group_add</i>
                              </a>
                            </TippyPopper>
                          );
                        }
                      })()}
                    </div>
                  </div>
                  <div className="in-call-content">
                    <div className="in-call-content__title">
                      <div className="in-call-content__title__icon">
                        <i className="material-icons">call</i>
                      </div>
                      {/* {this.state.consultacall} */}
                      <div className="in-call-content__title__text">
                        <TimeCounter
                          key={simult.value + "_" + contConsulta}
                          horario={duracao}
                        />
                      </div>
                    </div>
                    <div
                      onClick={(event) =>
                        this.CallConsultDisconnect(event, simult)
                      }
                      className="in-call-content__btn"
                    >
                      <i className="material-icons">call_end</i>
                    </div>
                  </div>
                  <div
                    key={simult.iduserout}
                    className="content"
                    id={"containerminichat" + simult.iduserout}
                    ref="containerchat"
                  >
                    {(() => {
                      contConsulta++;
                      NovaMensagemC = Messages[simult.iduserout];
                      if (NovaMensagemC === undefined) NovaMensagemC = [];
                    })()}
                    {NovaMensagemC.map((message, i) => {
                      if (message.dia != auxdia) {
                        dia = message.dia;
                        auxdia = message.dia;
                      } else {
                        auxdia = message.dia;
                        dia = "";
                      }
                      var positmessage1 = "message left";
                      var positmessage2 = "fav fav--left";
                      if (parseInt(message.author) === parseInt(InfoUsers.id)) {
                        positmessage1 = "message right";
                        positmessage2 = "fav fav--right";
                      }
                      var verifystar = this.state.active;
                      var mensagem_tratada = message.message.replace(
                        /¿/gi,
                        "\n"
                      );
                      if (message.typemsg === "2") {
                        var mensagem_tratada = mensagem_tratada.replace(
                          /§/gi,
                          "\r\n"
                        );
                      }
                      if (
                        parseInt(message.author) === InfoUsers.id &&
                        simult.iduserout === message.iduserout &&
                        message.typemsg === "0"
                      )
                        return (
                          <div key={i} className={positmessage1}>
                            <div className="time">{dia}</div>
                            <div className="bubble">
                              <div
                                className={
                                  message.favorite === "true"
                                    ? positmessage2 + " active"
                                    : positmessage2
                                }
                              >
                                {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Chat.iduserout)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                              </div>
                              <div
                                className="text"
                                style={{ whiteSpace: "pre-line" }}
                              >
                                <Highlighter
                                  highlightClassName="YourHighlightClass1"
                                  activeIndex="YourHighlightClass1"
                                  activeClassName="YourHighlightClass1"
                                  className="NovClass"
                                  searchWords={searchWords}
                                  textToHighlight={mensagem_tratada}
                                  sanitize={latinize}
                                />
                                <span className="text__end-spacing"></span>
                              </div>
                              <div className="bubble__info-content">
                                <div
                                  className="fav fav--inside fav--right"
                                  style={{ display: "none" }}
                                >
                                  <i className="material-icons fav-icon">
                                    star_border
                                  </i>
                                </div>
                                <div className="bubble__info-content__time">
                                  {message.datatime}
                                </div>
                                {(() => {
                                  if (positmessage1 != "message left") {
                                    return (
                                      <div
                                        className={
                                          "message-info message-info--" +
                                          message.statusmsg
                                        }
                                      >
                                        <i className="material-icons">
                                          done_all
                                        </i>
                                      </div>
                                    );
                                  }
                                })()}
                              </div>
                            </div>
                          </div>
                        );
                      else if (
                        parseInt(simult.iduserout) ===
                          parseInt(message.contactid) &&
                        message.typemsg === "0"
                      )
                        return (
                          <div key={i} className={positmessage1}>
                            <div className="time">{dia}</div>
                            <div className="bubble">
                              <div
                                className={
                                  message.favorite === "true"
                                    ? positmessage2 + " active"
                                    : positmessage2
                                }
                              >
                                {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Chat.iduserout)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                              </div>
                              <div
                                className="text"
                                style={{ whiteSpace: "pre-line" }}
                              >
                                <Highlighter
                                  highlightClassName="YourHighlightClass"
                                  searchWords={searchWords}
                                  autoEscape={true}
                                  textToHighlight={mensagem_tratada}
                                />
                                <span className="text__end-spacing"></span>
                              </div>
                              <div className="bubble__info-content">
                                <div
                                  className="fav fav--inside fav--right"
                                  style={{ display: "none" }}
                                >
                                  <i className="material-icons fav-icon">
                                    star_border
                                  </i>
                                </div>
                                <div className="bubble__info-content__time">
                                  {message.datatime}
                                </div>
                                {(() => {
                                  if (positmessage1 != "message left") {
                                    return (
                                      <div
                                        className={
                                          "message-info message-info--" +
                                          message.statusmsg
                                        }
                                      >
                                        <i className="material-icons">
                                          done_all
                                        </i>
                                      </div>
                                    );
                                  }
                                })()}
                              </div>
                            </div>
                          </div>
                        );
                      else if (
                        simult.iduserout === message.iduserout &&
                        message.typemsg === "2"
                      )
                        return (
                          <div key={i} className={positmessage1}>
                            <div className="time">{message.datatime}</div>
                            <div className="bubble">
                              <div
                                className={
                                  message.favorite === "true"
                                    ? positmessage2 + " active"
                                    : positmessage2
                                }
                              >
                                {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Chat.iduserout)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                              </div>
                              <div
                                className="text"
                                style={{ whiteSpace: "pre-line" }}
                              >
                                <Highlighter
                                  highlightClassName="YourHighlightClass"
                                  searchWords={searchWords}
                                  autoEscape={true}
                                  textToHighlight={mensagem_tratada}
                                />
                                <span className="text__end-spacing"></span>
                              </div>
                              <div className="bubble__info-content">
                                <div
                                  className="fav fav--inside fav--right"
                                  style={{ display: "none" }}
                                >
                                  <i className="material-icons fav-icon">
                                    star_border
                                  </i>
                                </div>
                                <div className="bubble__info-content__time">
                                  {message.datatime}
                                </div>
                                {(() => {
                                  if (positmessage1 != "message left") {
                                    return (
                                      <div
                                        className={
                                          "message-info message-info--" +
                                          message.statusmsg
                                        }
                                      >
                                        <i className="material-icons">
                                          done_all
                                        </i>
                                      </div>
                                    );
                                  }
                                })()}
                              </div>
                            </div>
                          </div>
                        );
                      else if (
                        simult.iduserout === message.iduserout &&
                        message.typemsg === "10"
                      ) {
                        var get_json = message.message;
                        let separadorurlcaption = get_json.split("~¿");
                        let thumbnail = separadorurlcaption[0];
                        let caption = separadorurlcaption[1];
                        let url = "";
                        if (caption) caption = caption.replace(/¿/gi, "\r\n");
                        if (caption == "null") caption = "";
                        if (separadorurlcaption[2]) {
                          let url = separadorurlcaption[2];
                          let separador = url.split(".");
                          let get_name = separador[0].split("/");
                          let verificarexistencia = "";

                          switch (separador[1].toLowerCase()) {
                            case "jpeg":
                            case "png":
                            case "jpg":
                              return (
                                <div className={positmessage1} key={message.id}>
                                  <div className="time">{message.datatime}</div>
                                  <div className="bubble">
                                    <div
                                      className={
                                        message.favorite === "true"
                                          ? positmessage2 + " active"
                                          : positmessage2
                                      }
                                    >
                                      {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Chat.iduserout)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                    </div>
                                    <div className="bubble-media">
                                      <div className="bubble-media__image">
                                        <ModalImage
                                          small={
                                            connection_platform.type_connect +
                                            "://" +
                                            ipcurrent +
                                            url
                                          }
                                          large={
                                            connection_platform.type_connect +
                                            "://" +
                                            ipcurrent +
                                            url
                                          }
                                          alt={get_name[6]}
                                          hideDownload={true}
                                          className="bubble-media__image-file"
                                        />
                                        {/* <img className="bubble-media__image-file" src={"http://"+ipcurrent+url} alt="" /> */}
                                      </div>
                                      <div className="bubble-media__mediaInfo">
                                        <span className="bubble-media__fileType">
                                          <img
                                            className="bubble-media__fileIcon"
                                            src={JPG}
                                            alt=""
                                          />
                                        </span>
                                        <span className="bubble-media__fileName">
                                          <p className="bubble-media__text">
                                            {get_name[6]}
                                          </p>
                                          <br />
                                          <div className="fileinfo__bar">
                                            <span className="fileinfo__size">
                                              130 KB
                                            </span>{" "}
                                            •{" "}
                                            <span className="fileinfo__type">
                                              {separador[1].toUpperCase()}
                                            </span>
                                          </div>
                                        </span>
                                        {(() => {
                                          if (InfoUsers.permdownload === true) {
                                            return (
                                              <div className="bubble-media__download">
                                                <a
                                                  href={
                                                    connection_platform.type_connect +
                                                    "://" +
                                                    ipcurrent +
                                                    url
                                                  }
                                                  target="_blank"
                                                  download
                                                  className="bubble-media__btnDownload"
                                                >
                                                  <i className="material-icons">
                                                    get_app
                                                  </i>
                                                </a>
                                              </div>
                                            );
                                          }
                                        })()}
                                      </div>
                                    </div>
                                    <div className="text">{caption}</div>
                                  </div>
                                </div>
                              );

                              break;
                            case "pdf":
                              if (thumbnail === " ") {
                                verificarexistencia = "";
                              } else {
                                verificarexistencia = (
                                  <div className="bubble-media__image">
                                    <ModalImage
                                      small={
                                        connection_platform.type_connect +
                                        "://" +
                                        ipcurrent +
                                        thumbnail
                                      }
                                      large={
                                        connection_platform.type_connect +
                                        "://" +
                                        ipcurrent +
                                        thumbnail
                                      }
                                      alt={get_name[6]}
                                      hideDownload={true}
                                      className="bubble-media__image-file"
                                    />
                                  </div>
                                );
                              }

                              return (
                                <div className={positmessage1} key={message.id}>
                                  <div className="time">{dia}</div>
                                  <div className="bubble">
                                    <div
                                      className={
                                        message.favorite === "true"
                                          ? positmessage2 + " active"
                                          : positmessage2
                                      }
                                    >
                                      {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Chat.iduserout)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                    </div>
                                    <div className="bubble-media">
                                      {verificarexistencia}
                                      <div className="bubble-media__mediaInfo">
                                        <span className="bubble-media__fileType">
                                          <img
                                            className="bubble-media__fileIcon"
                                            src={PDF}
                                            alt=""
                                          />
                                        </span>
                                        <span className="bubble-media__fileName">
                                          <p className="bubble-media__text">
                                            {get_name[6]}
                                          </p>
                                          <br />
                                          <div className="fileinfo__bar">
                                            <span className="fileinfo__size">
                                              130 KB
                                            </span>{" "}
                                            •{" "}
                                            <span className="fileinfo__type">
                                              {separador[1].toUpperCase()}
                                            </span>
                                          </div>
                                        </span>

                                        {(() => {
                                          if (InfoUsers.permdownload === true) {
                                            return (
                                              <div className="bubble-media__download">
                                                <a
                                                  href={
                                                    connection_platform.type_connect +
                                                    "://" +
                                                    ipcurrent +
                                                    url
                                                  }
                                                  target="_blank"
                                                  download
                                                  className="bubble-media__btnDownload"
                                                >
                                                  <i className="material-icons">
                                                    get_app
                                                  </i>
                                                </a>
                                              </div>
                                            );
                                          }
                                        })()}
                                      </div>
                                    </div>
                                    <div className="text">{caption}</div>
                                  </div>
                                </div>
                              );
                              break;
                            case "xls":
                            case "xlsx":
                            case "xlsm":
                            case "doc":
                            case "docx":
                            case "ppt":
                            case "pptx":
                              return (
                                <div className={positmessage1} key={message.id}>
                                  <div className="time">{message.datatime}</div>
                                  <div className="bubble">
                                    <div
                                      className={
                                        message.favorite === "true"
                                          ? positmessage2 + " active"
                                          : positmessage2
                                      }
                                    >
                                      {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Chat.iduserout)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                    </div>
                                    <div className="bubble-media">
                                      <div className="bubble-media__mediaInfo">
                                        <span className="bubble-media__fileType">
                                          <img
                                            className="bubble-media__image-file"
                                            src={
                                              connection_platform.type_connect +
                                              "://" +
                                              ipcurrent +
                                              url
                                            }
                                            alt=""
                                          />
                                        </span>
                                        <span className="bubble-media__fileName">
                                          <p className="bubble-media__text">
                                            {get_name[6]}
                                          </p>
                                          <br />
                                          <div className="fileinfo__bar">
                                            <span className="fileinfo__size">
                                              130 KB
                                            </span>{" "}
                                            •{" "}
                                            <span className="fileinfo__type">
                                              {separador[1].toUpperCase()}
                                            </span>
                                          </div>
                                        </span>

                                        {(() => {
                                          if (InfoUsers.permdownload === true) {
                                            return (
                                              <div className="bubble-media__download hide">
                                                <a
                                                  href={
                                                    connection_platform.type_connect +
                                                    "://" +
                                                    ipcurrent +
                                                    url
                                                  }
                                                  download
                                                  className="bubble-media__btnDownload"
                                                ></a>
                                              </div>
                                            );
                                          }
                                        })()}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                              break;
                            case "wav":
                            case "mp3":
                            case "ogg":
                            case "mpeg":
                              return (
                                <div className={positmessage1} key={message.id}>
                                  <div className="time">{message.datatime}</div>
                                  <div className="bubble">
                                    <div
                                      className={
                                        message.favorite === "true"
                                          ? positmessage2 + " active"
                                          : positmessage2
                                      }
                                    >
                                      {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Chat.iduserout)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                    </div>
                                    <div className="bubble-media">
                                      <div className="bubble-media__playerBar">
                                        <audio controls>
                                          <source
                                            src={
                                              connection_platform.type_connect +
                                              "://" +
                                              ipcurrent +
                                              url
                                            }
                                            type="audio/ogg"
                                          />
                                          <source
                                            src={
                                              connection_platform.type_connect +
                                              "://" +
                                              ipcurrent +
                                              url
                                            }
                                            type="audio/mpeg"
                                          />
                                          Your browser.
                                        </audio>
                                      </div>
                                      <div className="bubble-media__mediaInfo">
                                        <span className="bubble-media__fileType">
                                          <img
                                            className="bubble-media__fileIcon"
                                            src={MP3}
                                            alt=""
                                          />
                                        </span>
                                        <span className="bubble-media__fileName">
                                          <p className="bubble-media__text">
                                            {get_name[6]}
                                          </p>
                                          <br />
                                          <div className="fileinfo__bar">
                                            <span className="fileinfo__size">
                                              130 KB
                                            </span>{" "}
                                            •{" "}
                                            <span className="fileinfo__type">
                                              {separador[1].toUpperCase()}
                                            </span>
                                          </div>
                                        </span>

                                        {(() => {
                                          if (InfoUsers.permdownload === true) {
                                            return (
                                              <div className="bubble-media__download">
                                                <a
                                                  href={
                                                    connection_platform.type_connect +
                                                    "://" +
                                                    ipcurrent +
                                                    url
                                                  }
                                                  target="_blank"
                                                  download
                                                  className="bubble-media__btnDownload"
                                                >
                                                  <i className="material-icons">
                                                    get_app
                                                  </i>
                                                </a>
                                              </div>
                                            );
                                          }
                                        })()}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                              break;
                            case "mp4":
                              return (
                                <div className={positmessage1} key={message.id}>
                                  <div className="time">{message.datatime}</div>
                                  <div className="bubble">
                                    <div
                                      className={
                                        message.favorite === "true"
                                          ? positmessage2 + " active"
                                          : positmessage2
                                      }
                                    >
                                      {/* <i onClick={event => this.markstar2(me  ssage.messageid, InfoUsers.id, message.favorite, Chat.iduserout)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                    </div>
                                    <div className="bubble-media">
                                      <div className="bubble-media__video">
                                        <video
                                          className="bubble-media__video-frame"
                                          controls
                                        >
                                          <source
                                            className="bubble-media__video-file"
                                            src={
                                              connection_platform.type_connect +
                                              "://" +
                                              ipcurrent +
                                              url
                                            }
                                            type="video/mp4"
                                          />
                                          Seu navegador nao suporta esse tipo de
                                          arquivo.
                                        </video>
                                      </div>
                                      <div className="bubble-media__mediaInfo">
                                        <span className="bubble-media__fileType">
                                          <img
                                            className="bubble-media__fileIcon"
                                            src={AVI}
                                            alt=""
                                          />
                                        </span>
                                        <span className="bubble-media__fileName">
                                          <p className="bubble-media__text">
                                            {get_name[6]}
                                          </p>
                                          <br />
                                          <div className="fileinfo__bar">
                                            <span className="fileinfo__size">
                                              130 KB
                                            </span>{" "}
                                            •{" "}
                                            <span className="fileinfo__type">
                                              {separador[1].toUpperCase()}
                                            </span>
                                          </div>
                                        </span>

                                        {(() => {
                                          if (InfoUsers.permdownload === true) {
                                            return (
                                              <div className="bubble-media__download">
                                                <a
                                                  href={
                                                    connection_platform.type_connect +
                                                    "://" +
                                                    ipcurrent +
                                                    url
                                                  }
                                                  target="_blank"
                                                  download
                                                  className="bubble-media__btnDownload"
                                                >
                                                  <i className="material-icons">
                                                    get_app
                                                  </i>
                                                </a>
                                              </div>
                                            );
                                          }
                                        })()}
                                      </div>
                                    </div>
                                    <div className="text">{caption}</div>
                                  </div>
                                </div>
                              );
                              break;
                          }
                        }
                      }
                    })}

                    {/* <?php include"message-bubbles/_message-left.php";?>
                                        <?php include"message-bubbles/_message-right.php";?> */}
                  </div>
                  <div className="block-footer-mini-chat">
                    <div className="bottom">
                      <div className="message-box">
                        {/* <!-- <i className="material-icons bottom__input-send">send</i> --> */}
                        <div
                          className="active-chats__extra-input"
                          style={{ width: "100%" }}
                        >
                          <div
                            className="chat-message--mini-chat"
                            onKeyDown={(event) =>
                              this.handleKeyDownChat(event, simult.iduserout)
                            }
                            onKeyUp={(event) =>
                              this.handleOnChangeChat(
                                event,
                                InfoUsers,
                                simult,
                                simult.iduserout
                              )
                            }
                            ref={(input) => {
                              this.textInputChat = input;
                            }}
                            id={"chat-message-mini-chat" + simult.iduserout}
                            contentEditable="true"
                          ></div>
                          <button
                            onClick={(event) =>
                              this.ButtonSendMessageChat(
                                event,
                                InfoUsers.id,
                                InfoUsers,
                                simult,
                                "0",
                                simult.iduserout
                              )
                            }
                            type="submit"
                            className="btn btn-small btn--only-icon-mini-chat baseline"
                          >
                            <i className="material-icons">send</i>
                          </button>
                        </div>
                        {/* <a href="#" className="bottom__icon"><i className="material-icons">attach_file</i></a>
                                                <a href="#" className="bottom__icon"><i className="material-icons">mic_none</i></a> */}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })()}
            <a
              href="#"
              className="active-chats__link"
              onClick={(event) =>
                this.checkExpandAgent(
                  event,
                  simult.iduserout,
                  InfoUsers,
                  simult,
                  Chat
                )
              }
            >
              <i className="active-chats__maneger-top-icon fas fa-user"></i>
              <span className="active-chats__maneger-top">
                <i className="material-icons">person</i>
                Operador
              </span>
              <p className="active-chats__maneger-name tippy-default">
                {simult.agent}
              </p>
              {this.state.typing.map((typingtodo) =>
                (() => {
                  if (
                    typingtodo.typing == "1" &&
                    typingtodo.idatendimento == simult.iduserout
                  ) {
                    return (
                      <div className="bubble__typing--active-chats active">
                        <img
                          src={LOADING}
                          className="bubble__typing--active-chats--gestor"
                          alt=""
                          width="20"
                          height="auto"
                        />
                      </div>
                    );
                  }
                })()
              )}
            </a>
          </li>
        ))}
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatSimult);
